import dayjs from 'dayjs'

const config = {
    searchList: {
        searchTxt: [
            {
                name: '仓库人员编码',
                value: 'warehouseWorkerNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '身份证号',
                value: 'idCardNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '仓库人员名称',
                value: 'workerName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '薪资月份',
                value: 'month',
                type: 'time',
                timeType: 'month',
                format: 'yyyy-MM',
                placeholder: '薪资月份',
                unfold: true,
                span: 3
            },
            {
                name: '工资确认',
                value: 'confirmStatusList',
                unfold: true,
                type: 'select',
                multiple: true,
                optionNum: 'SALARY_CONFIRM_STATUS',
                options: [],
                span: 4
            },
            {
                name: '薪资未发原因',
                value: 'noPaySalaryReasonList',
                type: 'select',
                options: [],
                multiple: true,
                optionNum: 'NO_PAY_SALARY_REASON',
                unfold: true,
                span: 4
            },
            {
                name: '审批状态',
                value: 'auditStatusList',
                type: 'select',
                options: [],
                multiple: true,
                optionNum: 'SALARY_REASON_AUDIT_STATUS',
                unfold: true,
                span: 4
            },
            {
                'name': '业务场景',
                'value': 'businessSceneList',
                'type': 'select',
                'multiple': true,
                'optionNum': 'BUSINESS_SCENE',
                'options': [],
                'span': 3,
                'unfold': true,
            },
            {
                name: '创建时间',
                value: 'createTimeArr',
                type: 'time',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(6, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(30, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近两个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(60, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(90, 'd').toDate();
                                const end = dayjs().endOf('day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                    ]
                },
                unfold: true,
                span: 6,
            },
        ],
        unfoldState: false,
        // advancedBtn: true,
        // resetBtn: true,
    },
    searchTotalTitle: [],
    table: {
        // 'tableCut': true,
        // 'clickModify': true,
        // leftOperation: true,
        leftWidth: 120,
        selectBtn: true,
        height: 'calc(100vh - 168px)',
        columns: [
            {
                label: '仓库人员编码',
                prop: 'warehouseWorkerNo',
                width: '150px',
            },
            {
                label: '姓名',
                prop: 'workerName',
                width: '100px',
            },
            {
                label: '手机号码',
                prop: 'workerPhone_',
                width: '120px',
            },
            {
                label: '身份证号',
                prop: 'idCardNo_',
                width: '160px',
            },
            {
                label: '业务场景',
                prop: '_businessScene',
                info: '安心签-员工管理-业务场景名称',
                width: '130px',
            },
            {
                label: '发薪日期',
                prop: 'actualSalaryPayday',
                width: '100px',
            },
            {
                label: '发薪日期配置',
                prop: 'salaryPaydayCode',
                type: 'select',
                options: [],
                optionNum: 'SALARY_PAYDAY',
                width: '100px',
            },
            {
                label: '推送工资确认ID',
                prop: 'confirmCode',
                width: '170px',
            },
            {
                label: '主工作逻辑仓',
                prop: 'mainLogicalWarehouseName',
                width: '160px',
            },
            {
                label: '物理仓',
                prop: 'physicalWarehouseName',
                width: '150px',
            },
            {
                label: '逻辑仓',
                prop: 'logicalWarehouseName',
                width: '150px',
            },
            {
                label: 'MIP流程编码',
                prop: 'flowId',
                width: '160px',
            },
            {
                label: '工资确认',
                prop: 'confirmStatus',
                type: 'select',
                options: [],
                optionNum: 'SALARY_CONFIRM_STATUS',
                width: '160px',
            },
            {
                label: '薪资月份',
                prop: 'month_',
                width: '100px',
            },
            {
                label: '单据编码(合同)',
                prop: 'contractCode',
                width: '150px',
            },
            {
                label: '法务合同号(合同)',
                prop: 'legalContractCode',
                width: '150px',
            },
            {
                label: '合同名称',
                prop: 'contractName',
                width: '160px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '130px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '160px',
            },
            {
                label: '审批人',
                prop: 'approval',
                width: '160px',
            },
            {
                label: '审批状态',
                prop: 'auditStatus',
                type: 'select',
                options: [],
                optionNum: 'SALARY_REASON_AUDIT_STATUS',
                width: '160px',
            },
            {
                label: '原因反馈',
                prop: 'suggestion',
                width: '160px',
            },
            {
                label: '发送待办次数',
                prop: 'todoCount',
                width: '120px',
            },
            {
                label: '薪资未发原因',
                prop: '_noPaySalaryReason',
                width: '160px',
            },
            {
                label: '备注说明',
                prop: 'salaryReasonRemark',
                width: '100px',
            },
            {
                label: '附件',
                prop: 'fileName',
                width: '200px',
                type: 'button'
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '100px',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '160px',
            },
        ],
        action: [],
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 100],
    },
}
export default config
